<!-- 监测点的信息 -->
<template>
    <!-- <div class="point-info" :class="{ 'ab-msg-border': carrier.carrier.abnormal }" v-if="carrier.carrier"> -->
    <!-- fromType:是从新首页引入的该组件还是原来的监测点菜单，因为首页改成异常时边框颜色要闪烁 -->
    <div class="point-info" :class="{
        'ab-msg-border': fromType !=='home' && carrier.carrier.abnormal,
         'ab-border-red': fromType ==='home' && carrier.carrier.data_abnormal && !carrier.carrier.device_abnormal,
         'ab-border-yellow': fromType ==='home' && !carrier.carrier.data_abnormal && carrier.carrier.device_abnormal,
         'ab-border-red-yellow': fromType ==='home' && carrier.carrier.data_abnormal && carrier.carrier.device_abnormal,
         'width-small': fromType ==='home'
        }"
        v-if="carrier.carrier">
        <div class="header uk-flex uk-flex-between uk-flex-middle">
            <i class="el-icon-document" :title="$t('integration.details')"
                @click="carrierDetail(carrier.carrier.id, carrier.carrier.keycode, carrier.carrier.typeId)"></i>
            <h2>{{ carrier.carrier.keycode }}</h2>
            <div>
                <carrier-chart :carrierName="carrier.carrier.keycode" :carrierType="carrier.carrier.typeId" :sceneId="carrier.carrier.sceneId"
                    :structureId="carrier.carrier.description" :carrierId="carrier.carrier.id"></carrier-chart>
                <AlarmSwitch class="mr-5" :related="carrier.carrier.alarm_bind" :alarmSwitch="carrier.carrier.alarm_switch"
                    :scene-id="carrier.carrier.sceneId" :carrier-ids="[carrier.carrier.id]"
                    :carrier-type="carrier.carrier.typeId" :getList="() => $emit('updateCarrier', carrier.carrier.id)">
                </AlarmSwitch>
                <i class="el-icon-circle-close" :title="$t('public.btn_close')" @click="delPoint" v-show="!hide_close"></i>
            </div>
        </div>
        <div class="msg-middle middle-height">
            <CarrierInfoImg :carrier="carrier.carrier" :tab.sync="carrier.tab" :style="{width: fromType ==='home' ? '140px': '200px'}"> </CarrierInfoImg>
            <div class="uk-margin-small-left uk-flex-1">
                <SampleValue :sample_value="carrier.carrier.sample_value"
                    :probe_value="carrier.carrier.carrierDevice.isRangeList" :typeId="carrier.carrier.typeId"
                    :carrierName="carrier.carrier.keycode" :scopeName="carrier.carrier.fullPath.split('/')[0]"
                    :carrierId="carrier.carrier.id" :carrierTypeId="carrier.carrier.typeId" :carrierInfo="carrier.carrier">
                </SampleValue>
            </div>
        </div>
    </div>
</template>

<script>
import SampleValue from '@/components/SampleValue/SampleValue.vue';
import AlarmSwitch from '@/components/AlarmSwitch/AlarmSwitch';
import { carrierTypeConvert, carrierStatusConvert, traceConvert, alarmConvert, equiTypeConvert } from '@/utils/convert';
import { carrierDetail } from '@/utils/winDetail';
import CarrierInfoImg from '@/pages/dataBoard/MonitoringPoint/component/DisplayArea/component/component/CarrierInfoImg';
import CarrierChart from '@/components/CarrierChartIcon/CarrierChart.vue';
export default {
    props: ['carrier', 'fromType','hide_close'],
    watch: {
        carrier() {
            if (typeof this.carrier.carrier.sample_value === 'string') this.initEquiPoint();
        }
    },
    components: {
        SampleValue,
        CarrierInfoImg,
        AlarmSwitch,
        CarrierChart
    },
    // 顶部的开关  打开则会展示所有关联的设备点
    pointSwitch: {
        immediate: true,
        handler(newVal) {
            if (newVal) {
                // 控制锚点打开
            } else {
                // 控制锚点关闭
            }
        }
    },
    data() {
        return {
            carrierDetail,
            carrierTypeConvert,
            carrierStatusConvert,
            equiTypeConvert,
            traceConvert,
            alarmConvert,
            // 监测点顶部的开关
            pointSwitch: false,
            imgRate: 0,
            equiPoint: [],
            // 处理后的字段 因为需要将描述之类的信息连接起来
            tempProbe: [],
            humProbe: []
        };
    },
    mounted() {
        const img = new Image();
        img.src = this.carrier.carrier.carrierExtend && this.carrier.carrier.carrierExtend.pictureBase64;
        this.$nextTick(() => {
            const imgWidth = img.width;
            //const imgBoxWidth=this.$refs['img'].width;
            //this.imgRate=imgBoxWidth/imgWidth;
        });
        this.initEquiPoint();
    },
    methods: {
        // 将所有设备坐标和设备信息关联 一并展示
        initEquiPoint() {
            this.$set(this.carrier.carrier, 'sample_value', JSON.parse(this.carrier.carrier.sample_value || '{}'));
            this.equiPoint = this.carrier.carrier.carrierDevice.deviceList;
        },
        delPoint() {
            this.$emit('delPoint', this.carrier.carrier.id);
        }
    }
};
</script>

<style scoped lang="scss">
$ab-border: rgba(255, 66, 66, 0.5);
$border-color: #ccc;

::v-deep .middle-height {
    height: 240px;
}

.point-info {
    display: inline-block;
    width: 500px;
    height: 270px;
    margin: 0 15px 15px 0;
    border-radius: 2px;
    border: 1px solid $border-color;
    box-sizing: border-box;

    .header {
        height: 29px;
        padding: 0 10px;
        border-bottom: 1px solid $borderColor1;

        i {
            font-size: 16px;

            cursor: pointer;
        }

        h2 {
            flex: 1;
            font-weight: bold;
            text-align: center;
        }
    }

    .msg-middle {
        display: flex;
        padding: 10px;
        box-sizing: border-box;

        i {
            cursor: pointer;
        }
    }

    .msg-bottom {
        height: 150px;
        margin: 20px 10px 0 10px;

        .point-icon {
            display: inline-grid;
            width: 150px;

            grid-template-columns: 1fr 1fr;
            align-items: center;
            justify-items: center;

            i {
                display: inline-block;
                height: 75px;
                width: 75px;
                line-height: 75px;
                text-align: center;
                font-size: 25px;
            }

            :hover {
                background-color: rgba(48, 78, 114, 0.3);
                cursor: pointer;
            }
        }
    }

    &.width-small{
        width: 400px;
        // height: 250px;
    }
}

// 异常边框
.ab-msg-border {
    border: solid 2px $ab-border;
}


</style>
